<template>
    <div class="generator">
        <div class="sidebar">
            <div class="html">
                <textarea
                    name=""
                    id=""
                    cols="30"
                    rows="10"
                    v-model="htmlTemplate"
                    :placeholder="t('places-email_generator-placeholder')"
                ></textarea>
            </div>
            <div class="form">
                <div v-for="(value, field) in form" :key="field">
                    <!-- i18n-validator-ignore-next-line: displaying dynamic field name from form object -->
                    <label>{{ field }}</label>
                    <input type="text" v-model="form[field]" />
                </div>
            </div>
            <textarea
                name=""
                id=""
                cols="30"
                rows="10"
                :value="rendered"
            ></textarea>
        </div>
        <div class="preview">
            <div v-html="rendered"></div>
        </div>
    </div>
</template>
<script>
export default {
    data: () => ({
        htmlTemplate: "",
        form: {},
    }),
    computed: {
        rendered() {
            let content = this.htmlTemplate;
            for (let f in this.form) {
                let re = new RegExp(f, "g");
                content = content.replace(re, this.form[f]);
            }
            return content;
        },
    },
    watch: {
        htmlTemplate() {
            const re = /\{\{\{[a-z_]+\}\}\}/g;
            const fields = this.htmlTemplate.match(re);
            let form = {};
            for (let f in fields) {
                form[fields[f]] = this.form[fields[f]]
                    ? this.form[fields[f]]
                    : "";
            }
            this.form = form;
        },
    },
    mounted() {
        document.getElementsByTagName("title")[0].innerText =
            this.t("kevi_title_prefix") + " | " + this.t("places-email_generator-title");
    },
    methods: {
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
    },
};
</script>
<style>
.places-email-generator.page-content {
    max-width: 100%;
}
</style>
<style lang="less" scoped>
@import url("../colors");
.generator {
    display: flex;
    justify-content: stretch;
    height: 100vh;
    margin: -20px;
}
.sidebar {
    width: 30%;
    background: #ddd;
    border-right: 2px solid #555;
    flex-grow: 0;
}
.preview {
    background: #fff;
    flex-grow: 1;
}
</style>
